import React, {useEffect, useState} from 'react';
import '../App.css';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import {BrowserRouter as Router, Route, Routes} from "react-router-dom"
import applicationTheme from "../components/theme/applicationTheme";
import {LanguageProvider, LOCALES} from "../i18n";
//import type {} from '@mui/x-data-grid/themeAugmentation';
import Application from "../app/Application";
import Login from "../page/connection/Login";
import Protected from './Protected';
import ScrollToTop from '../components/ScrollToTop';
import SchoolYearLoader from '../components/SchoolYearLoader';
import GlobalErrorSnackbar from '../components/ui/snackbar/GlobalErrorSnackbar';
import {useSelector} from "react-redux";
import {ConfirmProvider} from "material-ui-confirm";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
// Side-effect: registers dayjs plugins + 'fr' locale before any picker/adapter runs.
import '../components/ui/time/pickerNormalize';

/**
 * IMS brand theme. The palette comes from `brandTokens.ts` (itself aligned with
 * `new-design.json`) and is shared by the Skote chrome and every routed page.
 */
const skoteTheme = createTheme(applicationTheme());

function App(props:any) {
    const [locale, setLocale] =  useState(LOCALES.FRENCH);
    const {isLoggedIn, lang} = useSelector((state:any) => state.user);
    const theme = skoteTheme;

    useEffect(() => {
        setLocale(lang);
    }, [lang]);

    return (
        <LanguageProvider locale={locale}>
            <ThemeProvider theme={theme}>
                {/* One root localization provider for ALL MUI X pickers.
                    (Per-form providers also exist and simply override the locale.) */}
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale.split('-')[0]}>
                <ConfirmProvider>
                    <GlobalErrorSnackbar />
                    <Router useTransitions={false}>
                        <ScrollToTop />
                        <Routes>
                            <Route path="/" element={<Login locale={locale} setLocale={setLocale}  />}  />

                            <Route path="/*" element={
                                <Protected isLoggedIn={isLoggedIn}>
                                    <SchoolYearLoader>
                                        <Application locale={locale} setLocale={setLocale} theme={theme}  />
                                    </SchoolYearLoader>
                                </Protected>
                            } />
                        </Routes>
                    </Router>
                </ConfirmProvider>
                </LocalizationProvider>
            </ThemeProvider>
        </LanguageProvider>
    );
}

export default App;
